import React, { useEffect, useState } from "react";
import "./footer.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../../images/footerlogo.svg";
import { FaFacebookSquare, FaLinkedin, FaInstagramSquare, FaPhoneAlt, FaAngleDoubleRight, FaMapMarkerAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import Akspoword from "../../images/aks-logo.png"
import { Link, NavLink } from "react-router-dom";
import axios from "axios";
import { BASE } from "../../App";
import { FaXTwitter } from "react-icons/fa6";

const Footer = () => {
  const [importLink, setImport] = useState([]);
  const [exportLink, setExport] = useState([]);
  const [domesticLink, setDomestic] = useState([]);
  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(BASE + "/navbar/");
        const p = res.data.data.navbar;

        const links = res.data.data.product_navbar;
        setImport([]);
        setExport([]);
        setDomestic([]);
        for (let i = 0; i < links.length; i++) {
          if (links[i].category.sub_category === "Import Finance") {
            setImport((prev) => [...prev, links[i]]);
          }
          if (links[i].category.sub_category === "Export Finance") {
            setExport((prev) => [...prev, links[i]]);
          }
          if (links[i].category.sub_category === "Domestic Finance") {
            setDomestic((prev) => [...prev, links[i]]);
          }
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetch();
  }, []);
  return (
    <footer>
        <div className="footer_container">
           <div className="footer_links">
               <div className="container-fluid">
                   <div className="row">
                     <div className="col-sm-6 col-lg-3">
                        <div className="footer_links_item">
                          <div className="footer_logo">
                            <Link to="/">
                              <img src={logo} alt="" />
                            </Link>
                          </div> 
                            <h5 className="text-white my-4">Tradeflair Corporate<br/> Services Pvt. Ltd</h5>

                            <div className="footer_media">
                              <a href="https://www.facebook.com/TradeflairCorporate?mibextid=wwXIfr&rdid=FU7tNfR9HzAaNTrL&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1AYzNndWtj%2F%3Fmibextid%3DwwXIfr#" target="_blank" rel="noopener noreferrer">
                                <FaFacebookSquare color="#fff" />
                              </a>
                              <a href="https://www.linkedin.com/company/tradeflair/" target="_blank" rel="noopener noreferrer">
                                <FaLinkedin color="#fff" />
                              </a>
                              <a href="https://x.com/TradeFlairCorp" target="_blank" rel="noopener noreferrer">
                                <FaXTwitter color="#fff" />
                              </a>
                            </div>           
                        </div>
                     </div>
                     <div className="col-sm-6 col-lg-4">
                        <div className="footer_links_item" style={{ marginBottom: "1rem" }}>
                             <div className="footer_import_finance_container">
                                <h3>Import Finance</h3>
                                {importLink.map((item) => {
                                  return (
                                    <Link key={item.id} to={`/product/${item.id}`}>
                                      <FaAngleDoubleRight color="#fff" /> {item.title}
                                    </Link>
                                  );
                                })}
                             </div>
                         </div>
                         <div className="footer_links_item" style={{ marginBottom: "1rem" }}>
                            <h3>Domestic finance</h3>
                            <div className="footer_import_finance_container">
                              {domesticLink.map((item) => {
                                return (
                                  <Link key={item.id} to={`/product/${item.id}`}>
                                  <FaAngleDoubleRight color="#fff" /> {item.title}
                                </Link>
                                );
                              })}
                            </div>
                          </div>
                          <div className="footer_links_item">
                            <h3>Export Finance</h3>
                            <div className="footer_import_finance_container">
                              {exportLink.map((item) => {
                                return (
                                  <Link key={item.id} to={`/product/${item.id}`}>
                                    <FaAngleDoubleRight color="#fff" /> {item.title}
                                  </Link>
                                );
                              })}
                            </div>
                          </div>
                      </div>
                     
                     <div className="col-sm-6 col-lg-2">
                         <div className="footer_links_item">
                              <h3>Site Links</h3>
                              <div className="footer_import_finance_container">
                                <Link to={`/about`} style={{ whiteSpace: "nowrap" }}>
                                <FaAngleDoubleRight color="#fff" />
                                  About us
                                </Link>
                                <Link to={`/career`} style={{ whiteSpace: "nowrap" }}>
                                <FaAngleDoubleRight color="#fff" />
                                  Career
                                </Link>
                                <Link to={`/blogs`} style={{ whiteSpace: "nowrap" }}>
                                <FaAngleDoubleRight color="#fff" />
                                  Blogs
                                </Link>
                                <Link to={`/contact`} style={{ whiteSpace: "nowrap" }}>
                                <FaAngleDoubleRight color="#fff" />
                                  Contact us
                                </Link>
                                <Link to={`/faq`}>
                                <FaAngleDoubleRight color="#fff" />
                                FAQS</Link>
                                <Link to={`/partner`} style={{ whiteSpace: "nowrap" }}>
                                <FaAngleDoubleRight color="#fff" />
                                  Partner with us
                                </Link>
                              </div>
                         </div>
                     </div>
                     <div className="col-sm-6 col-lg-3">
                          <div className="footer_links_item">
                            <h3>Contact us</h3>
                            <div className="footer_import_finance_container">
                              <p><FaMapMarkerAlt color="#fff" />
                              G-31, 1st Floor, Block G, <br/>Sector 3, Noida, <br/>Pincode - 201301
                                {/* 1st Floor,<br/> G-31, Block G,<br/> Sector 3, Noida<br/> 
                                Pincode - 201301 */}
                              </p>
                              <p><FaPhoneAlt color="#fff" /> +91 9810911531</p>
                              <p><MdEmail color="#fff" />sales@tradeflaircorporate.com</p>
                            </div>
                          </div>
                     </div>
                   </div>
               </div>
           </div>
      </div>
      <div className="footer_bottom">
        <p>Copyright © {new Date().getFullYear()} Trade Flair. All Rights Reserved.</p>
        <div className="footer_bottom_links">
          <Link to="/terms">Terms and Conditions</Link>
          <Link to="/refunds">Refund Policy</Link>
          <Link to="/disclaimer">Disclaimer </Link>
          <Link to="/cookies">Cookies Policy</Link>
          <Link to="/privacy">Privacy Policy</Link>
        </div>
        <a href="https://www.akswebsoft.com/" target="_blank" rel="noopener noreferrer">
          <img src={Akspoword} alt="AKS Websoft" />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
